module.exports = __webpack_public_path__ + "img/630-640-plan.ce9bc56f.jpg";